<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BillingCmlTarifMaster",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  